import Home from './pages/Home';
import Product from './pages/Product';
import Cart from "./pages/Cart";
import Orders from "./pages/Orders";
import Contact from "./pages/Contact";
import TermsofUse from "./pages/TermsofUse";
import Privacy from "./pages/Privacy";
import RefundReturn from "./pages/RefundReturn";
import Shipping from "./pages/Shipping";
import './App.css';
import usePageTracking from "./hooks/usePageTracking";
import { Routes, Route } from 'react-router-dom';
import SearchParam from "./manager/SearchParam";

function PageTracker() {
  usePageTracking();
  return null;
}

function App() {
  SearchParam();//Search params Manager
  return (
    <>
    <PageTracker />
    <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/product/:productId' element={<Product />} />
        <Route path='/my-cart' element={<Cart />} />
        <Route path='/orders/:id' element={<Orders />} />
        <Route path='/contact' element={<Contact />}/>
        <Route path='/terms' element={<TermsofUse />}/>
        <Route path='/privacy' element={<Privacy />}/>
        <Route path='/refund' element={<RefundReturn />}/>
        <Route path='/shipping' element={<Shipping />} />
    </Routes>
    </>
  );
}

export default App;
